import { inject, injectable } from 'inversify';
import { TYPES } from '@Types';
import { army_list_unit_troop, army_list_unit_troop_dto } from '@Api';
import { ArmyListUnitTroop } from '@Models';
import { TroopCaracMapper } from '../ninthAge/TroopCaracMapper';

@injectable()
export class ArmyListUnitTroopMapper {
  @inject(TYPES.Mapper.TroopCaracMapper)
  private _troopCaracMapper!: TroopCaracMapper;

  public map(item: army_list_unit_troop): ArmyListUnitTroop {
    return {
      id: item.id,
      troopId: item.troop_id,
      name: item.name ?? '',
      position: item.position,
      size: item.size,
      points: item.points,
      carac: this._troopCaracMapper.map(item.carac),
    } satisfies ArmyListUnitTroop as ArmyListUnitTroop;
  }

  mapDto(item: ArmyListUnitTroop): army_list_unit_troop_dto {
    return {
      id: item.id != '' ? item.id : null,
      troop_id: item.troopId,
      position: item.position,

      size: item.size,
      points: item.points,

      troop_type_id: item.carac.troop_type?.id ?? null,

      type_carac: this._troopCaracMapper.mapTypeDto(item.carac.type),

      M: item.carac.M,
      WS: item.carac.WS,
      BS: item.carac.BS,
      S: item.carac.S,
      T: item.carac.T,
      W: item.carac.W,
      I: item.carac.I,
      A: item.carac.A,
      LD: item.carac.LD,
      E: item.carac.E,

      carac_att: item.carac.att,
      carac_of: item.carac.of,
      carac_str: item.carac.str,
      carac_ap: item.carac.ap,
      carac_agi: item.carac.agi,
    } satisfies army_list_unit_troop_dto as army_list_unit_troop_dto;
  }
}
